import pluralize from "pluralize";

import { StripeInterval, SubscriptionInterval } from "@intelligems/ig-types";
import { CurrencyFormat } from "@src/features/admin/components/utils";

const Names = {
  CONTENT: "Content Testing (Legacy Plan)",
  PRICING: "Pricing Testing (Legacy Plan)",
  CAMPAIGNS: "Intelligems Campaigns (Legacy Plan)",
  PROFIT: "Profit Optimization (Legacy Plan)",
  BLUE: "Intelligems Blue (Legacy Plan)",
  SHIPPING: "Intelligems Shipping (Legacy Plan)",
  Unknown: "Intelligems (Legacy Plan)",
  "PAUSE PLAN": "Pause Plan",
};

const NameRegex = /(CONTENT|PRICING|CAMPAIGNS|PROFIT|BLUE|SHIPPING|PAUSE PLAN)/;

export const getDeprecatedValue = (value: string) => {
  return value.split(";")[0];
};

export const getDeprecatedName = (value: string) => {
  return value.split(";")[1];
};

export const formatDeprecatedName = (value?: string): string => {
  if (value) {
    const match = value?.match(NameRegex);
    if (match) {
      return Names[match[0]];
    }
  }
  return Names["Unknown"];
};

export const formatDeprecatedAmount = (
  amount: number,
  interval: StripeInterval,
  intervalCount: number
) => {
  if (intervalCount === 1) {
    return `${CurrencyFormat.format(amount)} / ${interval}`;
  }

  return `${CurrencyFormat.format(amount)} every ${intervalCount} ${pluralize(interval, intervalCount)}`;
};
